import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import NewspaperOutlinedIcon from '@mui/icons-material/NewspaperOutlined'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import ReviewsOutlinedIcon from '@mui/icons-material/ReviewsOutlined'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import { routeBackOfficeAllEntityAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeAllEntityAdminCommon'
import { routeBackOfficeGameAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeGameAdminCommon'
import { routeBackOfficeOrdersAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeOrdersAdminCommon.ts'
import { routeBackOfficeStudentAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeStudentAdminCommon'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'
import { CountryEnum } from '@/types/enum/enumUser'

const getBackOfficeGroupAdminCommon = [
  ...routeBackOfficeAllEntityAdminCommon,
  ...routeBackOfficeStudentAdminCommon,
  ...routeBackOfficeOrdersAdminCommon,
  ...routeBackOfficeGameAdminCommon,
  // Suivi financier GLOBAL (toutes entites confondues) — complementaire des pages
  // finance par entite (/backoffice/{entity}/finance).
  {
    route: 'FinanceOverview',
    menuGroup: MENU_GROUPS.MONITORING,
    t: 'routes.backoffice.group.financeOverview',
    text: 'Suivi financier global',
    icon: ReceiptLongIcon,
    href: '/backoffice/group/finance-overview',
    menuHeader: true,
    position: 200,
  },
  // Reprise par mini-lots des factures HORS PLATEFORME (serie FZ) non signees :
  // validation admin (equivalent du bouton de signature electronique du pharmacien),
  // puis transmission NetSuite par le cron ERP de 04h20. Hors menu depuis le 23/10/2026 :
  // l'ecran est une section de l'onglet « Hors Pharmedigroup » du Suivi financier global,
  // cette ancienne adresse y redirige.
  {
    route: 'InvoicesTeletransmit',
    menuGroup: MENU_GROUPS.MONITORING,
    t: 'routes.backoffice.group.invoicesTeletransmit',
    text: 'Factures hors plateforme',
    icon: SendOutlinedIcon,
    href: '/backoffice/group/invoices-teletransmit',
    menuHeader: false,
    position: 201,
    // Facturation electronique = France uniquement (meme gate que Mailing).
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
  // Retours des pharmaciens collectes apres signature de leur facture (Sound / Insight /
  // PLV). Transverse aux trois modules, d'ou sa place dans le back-office Group.
  {
    route: 'ProgramFeedback',
    menuGroup: MENU_GROUPS.MONITORING,
    t: 'routes.backoffice.group.programFeedback',
    text: 'Retours programmes',
    icon: ReviewsOutlinedIcon,
    href: '/backoffice/group/program-feedback',
    menuHeader: true,
    position: 211,
  },
  // Suivi GLOBAL des contrats (bascule Sound / StoreBag / Insight).
  {
    route: 'ContractsOverviewAdmin',
    menuGroup: MENU_GROUPS.MONITORING,
    t: 'routes.backoffice.group.contractsOverviewAdmin',
    text: 'Suivi contrats global',
    icon: DescriptionOutlinedIcon,
    href: '/backoffice/group/contracts-overview-admin',
    menuHeader: true,
    position: 210,
  },
  // Campagnes partenaires : proposition de repartition de budget (CIP + budget -> Sound/PLV)
  // + suivi des campagnes multi-programme (programmes Sound et StoreBag rattaches).
  {
    route: 'PartnerCampaignAdmin',
    menuGroup: MENU_GROUPS.MONITORING,
    t: 'routes.backoffice.group.partnerCampaignAdmin',
    text: 'Campagnes partenaires',
    icon: CampaignOutlinedIcon,
    href: '/backoffice/group/partner-campaign',
    menuHeader: true,
    position: 215,
  },
  // Calcul d'une proposition, EN PAGE : le geste dure plusieurs minutes et se lit dans un
  // tableau large — une modale n'a pas d'URL, se ferme d'un clic a cote et scrolle dans le
  // scroll. Hors menu : on y entre par le bouton de la liste des campagnes.
  {
    route: 'PartnerCampaignProposal',
    t: 'routes.backoffice.group.partnerCampaignProposal',
    text: 'Calcul d\'une proposition',
    icon: CampaignOutlinedIcon,
    href: '/backoffice/group/partner-campaign/proposal',
    menuHeader: false,
    position: 216,
  },
  // Suivi d'UNE campagne : une ligne par BUDGET de programme (une officine engagee sur le
  // Sound ET le PLV y tient deux lignes). Page de detail, hors menu.
  {
    route: 'PartnerCampaignTracking',
    t: 'routes.backoffice.group.partnerCampaignTracking',
    text: 'Suivi de la campagne',
    icon: CampaignOutlinedIcon,
    href: '/backoffice/group/partner-campaign/[campaignId]',
    menuHeader: false,
    position: 216,
  },
  // Equipements laboratoire : ce que chaque officine a demande (PLV fixe, radio) et ce
  // qu'elle a deja, avec la date de pose. Rattachee au suivi transverse et non au module
  // PLV : elle croise les catalogues de TOUS les laboratoires.
  {
    route: 'PartnerEquipmentAdmin',
    menuGroup: MENU_GROUPS.MONITORING,
    t: 'routes.backoffice.group.partnerEquipmentAdmin',
    text: 'Gestion des équipements',
    icon: HandymanOutlinedIcon,
    href: '/backoffice/group/partner-equipment',
    menuHeader: true,
    position: 216,
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_GROUP_ADMIN],
}))



// Roles dynamiques des admins metier — tous heritent de ROLE_ADMIN cote API
// (cf. role_hierarchy de security.yaml). Volontairement sans les roles "consult"
// (Care, School interne) : ils ne portent que ROLE_USER cote API et prendraient
// des 403 sur les endpoints proteges ROLE_ADMIN.
const ROLES_DYNAMIC_ALL_ADMINS = [
  CONSTANTS.ROLE_DYNAMIC_ROUTE_ROLE_SUPER_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_GROUP_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_PHARMEDICALL_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_SOUND_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_SOUND_ITALY_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_STORE_ADMIN,
  // Renomme STORE_BAG_ADMIN -> PLV_ADMIN par la separation PLV / centrale d'achat.
  CONSTANTS.ROLE_DYNAMIC_ROUTE_PLV_ADMIN,
]

// Routes accessibles a tous les roles admin (pas uniquement super admin).
const getBackOfficeGroupAllAdmins = [
  {
    // Actualite pharmacie : fil de lecture (tous admins France), moderation et sources RSS
    // (super admins seulement, onglets filtres dans NewsAdminPage). Contrat :
    // pharmedigroup-api/docs/ACTU_PHARMACIE.md. Endpoints admin en ROLE_SUPER_ADMIN, France uniquement
    // (sources francaises) : meme fnDisplay que Mailing, perimetre admin = dataMyProfile.countries.
    route: 'GroupActualitesAdmin',
    menuGroup: MENU_GROUPS.MONITORING,
    t: 'routes.backoffice.group.actualitesAdmin',
    text: 'Actualité pharmacie',
    icon: NewspaperOutlinedIcon,
    href: '/backoffice/group/actualites',
    menuHeader: true,
    position: 202,
    entity: [EntityList.PHARMEDIGROUP],
    roles: ROLES_DYNAMIC_ALL_ADMINS,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
  {
    route: 'Mailing',
    // Onglet Mailjet : rattache a la section « Outils » du menu v2, reserve aux
    // admins France (fnDisplay) — les admins BE/LU/IT ne doivent pas le voir.
    // Les endpoints API /mailjet/lists sont egalement restreints au pays FR.
    menuGroup: MENU_GROUPS.TOOLS,
    text: 'Mailing',
    icon: MailOutlineIcon,
    href: '/backoffice/group/mailing',
    menuHeader: true,
    position: 900,
    entity: [EntityList.PHARMEDIGROUP],
    roles: ROLES_DYNAMIC_ALL_ADMINS,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
]

const getBackOfficeGroupAdmin = [...getBackOfficeGroupAdminCommon, ...getBackOfficeGroupAllAdmins]

export default getBackOfficeGroupAdmin
